<form [formGroup]="inputForm">
  <form-row>
    <mat-checkbox [formControlName]="controlName" (change)="changedCheckBox($event)" [disabled]="disable">
      <span [innerHTML]="inputText | safeHtmlPipe"></span>
      <span *ngIf="inputLink">
        (
        <a href="{{ inputLink }}" target="_blank">Link zur Datei</a>
        )
      </span>
    </mat-checkbox>
  </form-row>
  <mat-error *ngIf="!inputForm.controls[controlName].valid && inputForm.controls[controlName].touched">
    Bitte akzeptieren Sie alle Bedingungen
  </mat-error>
  <!-- Weitere Bedingungen -->
  <ng-content />
</form>
